@if (!appSettings.isMobile()) {
    <div>
        <div class="row mb-3 align-items-end g-2">
            <div class="col-md-3">
                <label class="form-label small text-muted mb-1">Categoría</label>
                <ng-select [items]="categories()"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Todas"
                    [clearable]="true"
                    [(ngModel)]="categoryFilter"
                    (change)="applyFilters()">
                </ng-select>
            </div>
            <div class="col-md-4">
                <label class="form-label small text-muted mb-1">Buscar</label>
                <input type="text" class="form-control" placeholder="Nombre, slug o abreviatura"
                    [(ngModel)]="searchText" (ngModelChange)="applyFilters()">
            </div>
            <div class="col-md-5 d-flex justify-content-end">
                <ng-content></ng-content>
            </div>
        </div>

        <div class="table-responsive table-data mb-3">
            <table class="table table-hover table-sm align-middle">
                <thead>
                    <tr>                        
                        <th>Icono</th>
                        <th role="button" (click)="orderCol('slug')">Slug</th>                        
                        <th role="button" (click)="orderCol('category')">Categoría</th>
                        <th role="button" (click)="orderCol('name')">Nombre</th>
                        <th role="button" (click)="orderCol('settlementTarget')">Contable</th>
                        <th class="text-center">Módulos</th>
                        <th class="text-center"><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @if (isLoading) {
                        @for (i of rows; track $index) {
                            <tr class="tr-custom">
                                @for (c of [1,2,3,4,5,6,7,8]; track c) {
                                    <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                                }
                            </tr>
                        }
                    }

                    @for (proc of filteredProcesses; track proc.uuid) {
                        <tr [class.table-active]="selectedUuid() === proc.uuid">
                                                        <td>
                                @if (proc.icon) {
                                    <i [class]="proc.icon + ' text-secondary me-1'"></i>
                                } @else {
                                    <small class="text-muted">-</small>
                                }
                            </td>
                            <td><code class="small">{{ proc.slug }}</code></td>
                                                <td>
                                <span >
                                    {{ categoryLabel(proc) }}
                                </span>
                            </td>
                            <td class="fw-semibold">{{ proc.name }}</td>
                          
                            <td>
                                @if(proc.settlementTarget === 'ENTITY_PAYMENT' || proc.settlementTarget === 'REIMBURSEMENT'){
                                <span class="badge border" [class.text-bg-success]="proc.settlementTarget === 'ENTITY_PAYMENT'"
                                      [class.text-bg-info]="proc.settlementTarget === 'REIMBURSEMENT'">
                                    {{ settlementLabel(proc.settlementTarget) }}
                                </span>
                                } @else {
                                    <small class="text-muted"></small>
                                }
                            </td>
                            <td class="text-center text-nowrap">
                                @if (proc.usesBpm) {
                                    <span class="badge border text-primary me-1" title="Usa BPM">BPM</span>
                                }
                                @if (proc.requiresDocuments) {
                                    <span class="badge border text-secondary" title="Usa documentos">Docs</span>
                                }
                                @if (!proc.usesBpm && !proc.requiresDocuments) {
                                    <span class="text-muted small">—</span>
                                }
                            </td>

                            <td class="text-end">
                                <div class="btn-group btn-group-sm">
                                    @if (perm.canCurrent('canUpdate')) {
                                    <button class="btn btn-outline-primary bt-xs" title="Editar" (click)="selectProcess(proc)">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    }
                                    @if (perm.canCurrent('canDelete')) {
                                    <button class="btn btn-outline-danger bt-xs" title="Eliminar" (click)="deleteProcess(proc)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </tr>
                    }

                    @if (!isLoading && filteredProcesses.length === 0) {
                        <tr>
                            <td colspan="8" class="text-center text-muted py-4">
                                <i class="fas fa-inbox fa-2x mb-2 d-block opacity-50"></i>
                                No se encontraron procesos registrados
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
} @else {
    <app-mobile-footer>
        <input type="search"
               class="form-control mobile-footer-search"
               placeholder="Buscar nombre, slug o abreviatura..."
               [(ngModel)]="searchText"
               (ngModelChange)="applyFilters()">
        <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
                [class.btn-outline-primary]="categoryFilter !== null"
                (click)="mobileFiltersOpen = true">
            <i class="fas fa-filter me-1"></i>Filtros
            @if (categoryFilter !== null) {
                <span class="badge bg-primary ms-1">1</span>
            }
        </button>
    </app-mobile-footer>
    <app-bottom-sheet [open]="mobileFiltersOpen" title="Filtros" (closed)="mobileFiltersOpen = false">
        <div class="d-flex flex-wrap gap-2 px-3 pb-3">
            <span class="filter-badge"
                  role="button"
                  tabindex="0"
                  [class.active]="categoryFilter === null"
                  (click)="setCategoryFilter(null)">
                Todas
            </span>
            @for (cat of categories(); track cat.value) {
                <span class="filter-badge"
                      role="button"
                      tabindex="0"
                      [class.active]="categoryFilter === cat.value"
                      (click)="setCategoryFilter(cat.value)">
                    {{ cat.label }}
                </span>
            }
        </div>
    </app-bottom-sheet>

    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <span class="small text-muted fw-bold text-uppercase">
            REGISTROS @if (!isLoading) { ({{ filteredProcesses.length }}) }
        </span>
    </div>

    <div class="mobile-cards-scroll">
        @if (isLoading) {
            @for (i of rows; track $index) {
                <app-list-card [isLoading]="true"></app-list-card>
            }
        } @else {
            @for (proc of filteredProcesses; track proc.uuid) {
                <app-list-card
                    [isShortcut]="true"
                    (click)="selectProcess(proc)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        <i [class]="(proc.icon || 'fas fa-cog') + ' me-1 text-secondary'"></i>
                        {{ proc.name }}
                    </div>
                    <div cardBadge>
                        <strong class="text-secondary">
                            {{ categoryLabel(proc) }}
                        </strong>
                        <span class="badge border ms-1 small">{{ settlementLabel(proc.settlementTarget) }}</span>
                        @if (proc.usesBpm) {
                            <span class="badge border text-primary ms-1 small">BPM</span>
                        }
                        @if (proc.requiresDocuments) {
                            <span class="badge border text-secondary ms-1 small">Docs</span>
                        }
                    </div>

                    <div class="row g-1 text-muted small">
                        <div class="col-7">
                            <span class="text-muted">Slug</span>
                            <div><code class="small">{{ proc.slug }}</code></div>
                        </div>
                        <div class="col-5 text-end">
                            <span class="text-muted">Abrev.</span>
                            <div class="fw-semibold text-dark">{{ proc.abbr || '—' }}</div>
                        </div>
                    </div>
                </app-list-card>
            }
        }

        @if (!isLoading && filteredProcesses.length === 0) {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-cogs fa-3x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">Sin procesos</h6>
                <small class="text-muted">Ajusta los filtros o crea uno nuevo.</small>
            </div>
        }
    </div>
}
